module.exports = __webpack_public_path__ + "media/registration/check-mark-1-b193c469.svg";